<template>
  <div class="my-layout-box">
    <!-- 基本信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>基本信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>姓名: </span>
            <i class="c-three-color">{{ items.RealName }}</i>
          </li>
          <li>
            <span>账号: </span>
            <i>{{ items.UserName }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>手机: </span>
            <i>{{ items.Mobile }}</i>
          </li>
          <li>
            <span>邮箱: </span>
            <i>{{ items.Email }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 公司信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>公司信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>公司全称：</span>
            <i class="c-three-color">{{ items.Name }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>公司法人： </span>
            <i>{{ items.GS_CorporatePerson }}</i>
          </li>
          <li>
            <span>注册资金(万元)：</span>
            <i>{{ items.GS_RegCapital }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>社会信用证号：</span>
            <i>{{ items.GS_CreditCode }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>组织机构代码：</span>
            <i>{{ items.GS_OrgCode }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>工商注册号：</span>
            <i>{{ items.GS_RegCode }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>注册地址：</span>
            <i>{{ items.GS_RegAddress }}</i>
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>实名认证：</span>
            <i :class='isOrganizationAuth? "c-four-color": "c-two-color"'>{{ isOrganizationAuth ? "已认证" : "未认证" }}</i>
          </li>
          <li>
            <span>营业执照：</span>
            <i :class='isLicense? "c-four-color": "c-two-color"'>{{ isLicense ? "已上传" : "未上传" }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 开票信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>开票信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>税务登记证: </span>
            <i>{{ items.GS_TaxRegCode }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>开 户 行: </span>
            <i>{{ items.FP_BankName }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>银行帐号: </span>
            <i>{{ items.FP_BankAccount }}</i>
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>开票电话: </span>
            <i>{{ items.FP_Mobile }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>收票联系人: </span>
            <i>{{ items.ReceiptInvoicePerson }}</i>
          </li>
          <li>
            <span>收票电话: </span>
            <i>{{ items.ReceiptInvocePhone }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>收票地址: </span>
            <i>{{ items.ReceiptInvoceAddresss }}</i>
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>开票资料: </span>
            <i :class='isInvoice? "c-four-color": "c-two-color"'>{{ isInvoice ? "已上传" : "未上传" }}</i>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>
<script>
import { getUser } from "~/api/userCenter";
export default {
  name: "myMessage",
  computed: {
    isOrganizationAuth() {
      return this.items.ESignOrganizationAuthAt != null;
    },
    isInvoice() {
      return this.InvoiceUploads.length > 0;
    },
    isLicense() {
      return this.LicenseUploads.length > 0;
    }
  },
  data() {
    return {
      items: {
        RealName: "",
        UserName: "",
        Email: "",
        Mobile: "",
        Name: "",
        GS_RegAddress: "",
        GS_CorporatePerson: "",
        GS_RegCapital: "",
        GS_OrgCode: "",
        GS_CreditCode: "",
        GS_RegCode: "",
        GS_TaxRegCode: "",

        FP_BankName: "",
        FP_BankAccount: "",
        FP_CompanyAddress: "",
        FP_Mobile: "",
        ReceiptInvoicePerson: "",
        ReceiptInvocePhone: "",
        ReceiptInvoceAddresss: "",

        ESignAccountAuthAt: null,
        ESignOrganizationAuthAt: null
      },
      InvoiceUploads: [],
      LicenseUploads: []
    };
  },
  methods: {
    async getData() {
      const data = await getUser();
      if (data) {
        Object.keys(this.items).forEach(key => {
          this.items[key] = data[key];
        });
        this.InvoiceUploads = data.InvoiceUploads;
        this.LicenseUploads = data.LicenseUploads;
      }
    }
  },
  async created() {
    await this.getData();
  }
};
</script>
